<template>
     <nav>  
    <router-link class="logo" to="/">
        <img class="logo-img" src="../assets/icons/main-logo.svg"
    </router-link>
    <div class="links">

        <router-link class="link" to="/">Home</router-link>
        <router-link class="link" to="/about">About</router-link>
        <router-link class="link" to="/work-education">Work & Education</router-link>
        <router-link class="link" to="/sample-projects">Sample Projects</router-link>
        <router-link class="link" to="/contacts">Contacts</router-link>
        <button @click="ToggleMenu()">
            <img src="../assets/icons/menu.svg"/>  
        </button>
    </div>
    <div class="menu">
            <router-link to="/" @click="ToggleMenu()" class="menu-item">
                Home
            </router-link>
            <router-link to="/about" @click="ToggleMenu()" class="menu-item">
                About
            </router-link>
            <router-link to="/work-education" @click="ToggleMenu()" class="menu-item">
                Work & Education
            </router-link>
            <router-link to="/sample-projects" @click="ToggleMenu()" class="menu-item">
                Sample Projects
            </router-link>
            <router-link to="/contacts" @click="ToggleMenu()" class="menu-item">
                Contacts
            </router-link>
        </div>
  </nav>
</template>
<script>
export default{
    methods:{
        ToggleMenu(){
            let menu = document.querySelector('.menu');
            menu.classList.toggle('menu-toggle');
        }
    }
}
</script>
<style scoped>

.router-link-exact-active{
        color:var(--gold);
    }

.links{
    display:flex;
    justify-content: space-between;
    min-width:50vw;
}

button{
    background-color: transparent;
    border:0px;
    display: none;
    position: relative;
    
}

.menu{
   
    position: absolute;
    margin-top:18rem;
    color:white;
    background-color: var(--blue);
    border-radius: 9px;
    margin-right: 0.5rem;
    right:0;
    display: none;
    grid-template-columns: repeat(2, 1fr);
    width:15rem;
   
}

.nav-color{
    background-color: var(--blue);
}

nav{
    background-color: var(--blue);
    display:flex;
    justify-content: space-between;
    align-items: center;
    padding:0.5 4rem;
    position:fixed;
    z-index:10;
  top:0;
  left:0;
  right:0;
}

nav a {
  color:white;
  text-decoration: none;
  font-size: 0.9rem;
 
}

/* nav a.router-link-exact-active {
  color: #42b983;
} */

.logo{
    display: flex;
    justify-content: center;
}

.logo-img{
    height:2.5rem;
}

nav .logo.router-link-exact-active {
  color: black;
  text-decoration: none;
}




@media(max-width: 950px){
    .links{  
    width:60vw;
}   
}



@media(max-width: 768px){
    button{
    display: block;
    }

    .link{
        display:none;
    }

    .menu{
        grid-template-columns:1fr;
        padding:0.8rem 1rem;
        
    }

   
    
    .menu-toggle{
        display:grid;
    }

    .menu-item{
        margin-bottom:1rem;
        font-size:1rem;
    }

    

    .links{
        justify-content: flex-end;
    }
}
</style>